module.exports = __webpack_public_path__ + "img/cate-icon-6.aada2a92.png";